import Entities from 'STORE';

export function endReplyMessage(groupId: string | null): void {
  const inputPanel = groupId
    ? Entities.InputPanelsStore.getById(groupId)
    : Entities.InputPanelsStore.activeInputPanel;

  if (inputPanel && inputPanel.replyMessage) {
    inputPanel.setReplyMessage(null);
  }
}
